import { useNavigate } from "react-router-dom"
import { create } from "../../services/services"

const PlanCard = ({ plan, from,free=false }) => {
  // console.log({ plan })
  const navigate = useNavigate()
  
  const ChoosePlan = (plan) => {
    if (from === 'account') {
      navigate(`/compte/prestataire/mon-plan/paiement`, { state: { plan,free } })
    } else if(from==="landingPage"){
      navigate(`/registerPrestataire`, { state: { plan: plan } })

    }
    else {
      navigate(`/billingaddress`, { state: { plan: plan } })
    }
  }

  // Calculate prices once
  const statiquePrice=59.99
  const originalMonthlyPrice = (parseFloat(plan?.default_price_eur) / parseInt(plan?.duration_in_months)).toFixed(2)
  const discountedMonthlyPrice = (parseFloat(plan?.discounted_price_eur) / parseInt(plan?.duration_in_months)).toFixed(2)
  const savings = parseFloat(statiquePrice*parseInt(plan?.duration_in_months)) - parseFloat(plan?.discounted_price_eur)

  return (
    <div className={(from === "account" || from==="landingPage") ? "col-md-4 padding-8 p-relative" : "col-md-3 padding-8 p-relative"}>
      <div className={`${plan?.duration_in_months==36? 'selected-plan' :''} card-border`}>
        {/* Only show savings label if not from account */}
        {(from !== "account" || free) && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="container-label p-absolute top">
              <span className="card-label">Économisez {parseInt(Math.ceil(savings))}€</span>
            </div>
          </div>
        )}
        
        <div className="card-padding" style={from === "account" ? { paddingTop: '24px' } : {}}>
          <h4 className="card-title mb-24">Plan {plan?.duration_in_months} mois</h4>
           {/* Original price (always shown) */}
          {(from !== "account" || free) && ( 
           
          <h5 className="card-text text-decoration">{statiquePrice}€</h5>
          )}
          {/* Discounted price (always shown) */}
          <h2 className="card-price mt-25">
             {(from !== "account" || free) ? discountedMonthlyPrice : originalMonthlyPrice}€ <span className="col card-text">/mois</span>
          </h2>
          
          {/* Renewal price (always shown) */}
          <p className="col card-text">
            Le plan est ensuite renouvelé à {originalMonthlyPrice}€ /mois
          </p>
          
          <div className="d-flex mt-24">
            <img src="/images/check-01.svg" alt='check' />{" "}
            <span className="text-body-card">Aucune commission</span>
          </div>
          <div className="d-flex">
            <img src="/images/check-01.svg" alt='check' />{" "}
            <span className="text-body-card">Accès illimité</span>
          </div>
          <div className="d-flex">
            <img src="/images/check-01.svg" alt='check' />{" "}
            <span className="text-body-card">
              Frais de gestion compris
            </span>
          </div>
          <div className="d-flex">
            <img src="/images/check-01.svg" alt='check' />{" "}
            <span className="text-body-card">
              Frais de traitement bancaire gratuits
            </span>
          </div>
        </div>
        <button
          type="button"
          className={`${plan?.duration_in_months==36? 'twyny-cta-primary bottom-spacing' :'twyny-cta-secondary bottom-spacing'} `}
          onClick={() => { ChoosePlan(plan) }}
        >
          Commencer pour {plan?.duration_in_months} mois
        </button>
      </div>
    </div>
  )
}

export default PlanCard